export default {
  drawer: null,
  loading: false,
  showErrorDialog: false,
  errorMessage: "",
  errorCode: "",
  reload: false,
  showBulkRefundDialog: false,
  showBroadcastDialog: false,
  showMapDialog: false,
  showQRDialog: false,
  QRDialogMessage: "",
  QRDialogName: "",
  QRDialogDownloadFileName: "",
};
